// Login screen — Linear'ın e-posta giriş ekranı dili (spec 2026-08-03).
//
// 🔴 Ekran BUTONLA BİTER. Kaldırılanlar ve sebepleri (hepsi 2026-08-03'te ölçüldü):
//   · "Beni hatırla"      → state vardı ama login()'e hiç geçmiyordu
//   · "Şifremi unuttum"   → href="#" + preventDefault(), ölü link. S311'de GERİ GELDİ:
//                           artık e-posta gönderebiliyoruz (noreply@raporgor.com,
//                           kullanıcı 2026-09-27) ve bağlantı gerçek bir rotaya gidiyor.
//   · "Demo talep edin"   → aynı desen, ölü link
//   · "Sistem Çevrimiçi"  → sabit metin, hiçbir sağlık kontrolüne bağlı değil
//   · "v2.4.1"            → elle yazılmış sürüm, build'den gelmiyor
//   · güven şeridi        → "ISO 27001" iddiası doğrulanmamıştı
// Kapılar Login.test.tsx'te; geri koyarsanız test kırılır.
import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { I } from '../components/yeni-design/icons';
import { Wordmark } from '../components/yeni-design/Wordmark';
import { girisAltLinkCls } from '../components/GirisKabugu';

export function LoginPage() {
  const { login, isDemo } = useAuth();
  const navigate = useNavigate();

  const [showPwd, setShowPwd] = useState(false);
  const [email, setEmail] = useState('');
  const [pwd, setPwd] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      if (isDemo) {
        await login();
      } else {
        await login(email.trim(), pwd);
      }
      navigate('/', { replace: true });
    } catch (err) {
      let msg = 'Giriş başarısız. E-posta ve şifrenizi kontrol edin.';
      if (axios.isAxiosError(err)) {
        const status = err.response?.status;
        if (status === 401 || status === 403) {
          msg = 'E-posta veya şifre hatalı.';
        } else if (status === 429) {
          msg = 'Çok fazla deneme. Lütfen birkaç dakika sonra tekrar deneyin.';
        } else if (status && status >= 500) {
          msg = 'Sunucuya ulaşılamıyor. Lütfen tekrar deneyin.';
        } else if (err.response?.data && typeof err.response.data === 'object') {
          const body = err.response.data as { message?: string; error?: string };
          if (body.message) msg = body.message;
          else if (body.error) msg = body.error;
        }
      } else if (err instanceof Error && err.message) {
        msg = err.message;
      }
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  // Ölçüler Yerlice'nin login.css'iyle BİREBİR aynı; burada Tailwind arbitrary
  // değerleriyle taşınıyor. Ayrışmayı loginOlculeri.test.ts yakalar.
  // 🔴 #6b6b6e (Yerlice görevinden devralınan karar): #8e8e91 beyaz üstünde
  // 3,27 kontrast verir, bu repoda WCAG AA (4,5) kapısı var. #6b6b6e → 5,31.
  // 🔴 focus:outline-none tarayıcının yerel odak halkasını kaldırıyor; yerine Yerlice
  // login.css'teki `box-shadow: 0 0 0 3px rgba(18,58,105,0.15)` ile birebir aynı odak
  // gölgesi kondu (WCAG 2.4.7 — odağın görünür kalması gerekir).
  const inputCls =
    'w-full h-[44px] rounded-[10px] border-[0.5px] border-[#d2d2d2] bg-[#f8f8f9] ' +
    'px-3 text-[13px] max-[640px]:text-[16px] text-[#1b1b1b] placeholder:text-[#6b6b6e] ' +
    'focus:outline-none focus:border-[#123A69] focus:shadow-[0_0_0_3px_rgba(18,58,105,0.15)]';

  return (
    <div className="min-h-[100dvh] bg-[#f8f8f9] flex items-center justify-center p-6">
      <form className="w-[288px] flex flex-col" onSubmit={handleSubmit} noValidate>
        {/* Wordmark bileşeni "Gör" hecesini text-brand-700 (#1e40af) ile basıyor; bu ekranda
            buton mavisi #123A69. Wordmark.tsx'i DEĞİŞTİRMİYORUZ — aynı bileşen Layout'ta da
            kullanılıyor, orada renk değiştirmek panel geneli bir marka kararı olur ve bu
            turun kapsamında değil. Bunun yerine YALNIZ bu sayfada, Wordmark'ın ürettiği
            .text-brand-700 sınıfını sarmalayıcı üzerinden ezip #123A69'a çeviriyoruz. */}
        {/* Dikey dizilim + 64px mark + 20/700 wordmark: Yerlice login.css'teki `.rg-login__mark` ile BİREBİR.
            Wordmark.tsx yine DEĞİŞTİRİLMİYOR — aynı bileşen Layout'ta yatay kullanılıyor,
            oradaki dizilimi bozmamak için ezme yalnız bu sayfanın sarmalayıcısında.
            `[&>div]` seçicisi (0,2,0) Wordmark'ın kendi `gap-2` sınıfını (0,1,0) yener.
            Punto/kalınlık ezmesi `[&>div>span]` ile YALNIZ dış span'e gider; `[&_span]`
            olsaydı "Gör" hecesinin iç span'ine de inerdi — şu an gereksiz ama ileride
            iç span'e ayrı bir punto verilirse sessizce ezerdi. */}
        <div className="flex justify-center mb-[22px] [&_.text-brand-700]:text-[#123A69] [&>div]:flex-col [&>div]:gap-[12px] [&_img]:w-[64px] [&_img]:h-[64px] [&>div>span]:text-[20px] [&>div>span]:font-bold [&>div>span]:tracking-[-0.02em]">
          <Wordmark size="md" />
        </div>

        {/* Başlık GÖRSEL olarak kaldırıldı (kullanıcı 2026-08-03). Eleman SİLİNMEDİ:
            sayfadaki tek <h1> buydu, kaldırılsaydı ekran okuyucuda başlıksız sayfa kalırdı.
            `sr-only` akıştan çıkarır; Yerlice login.css'teki `.rg-login__h1` ile BİREBİR. */}
        <h1 className="sr-only">Giriş yap</h1>

        <label htmlFor="eposta" className="text-[11px] font-medium text-[#4b4b4f] mb-[5px] ml-0.5">
          E-posta
        </label>
        <input
          id="eposta"
          type="email"
          className={`${inputCls} mb-3`}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="ornek@firma.com.tr"
          autoComplete="username"
          required
        />

        <label htmlFor="sifre" className="text-[11px] font-medium text-[#4b4b4f] mb-[5px] ml-0.5">
          Şifre
        </label>
        <div className="relative mb-3">
          <input
            id="sifre"
            type={showPwd ? 'text' : 'password'}
            className={`${inputCls} pr-10`}
            value={pwd}
            onChange={(e) => setPwd(e.target.value)}
            autoComplete="current-password"
            required
          />
          <button
            type="button"
            onClick={() => setShowPwd((s) => !s)}
            aria-label={showPwd ? 'Şifreyi gizle' : 'Şifreyi göster'}
            className="absolute right-0 top-0 w-10 h-[44px] flex items-center justify-center bg-transparent text-[#6b6b6e] hover:text-[#2f2f31] cursor-pointer"
          >
            {showPwd ? <I.EyeOff size={16} /> : <I.Eye size={16} />}
          </button>
        </div>

        {error && (
          <p role="alert" className="text-[12px] text-[#b42318] text-center mt-1 mb-3">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={submitting}
          className="h-[44px] mt-1 rounded-[9999px] bg-[#123A69] text-white text-[13px] font-medium disabled:opacity-60 cursor-pointer disabled:cursor-default"
        >
          {submitting ? 'Giriş yapılıyor…' : 'Giriş Yap'}
        </button>

        {/* S311: demo panellerinde YOK. Onlar kullanıcı parolasıyla değil derleme anındaki
            API anahtarıyla giriyor; sıfırlanacak bir parola yok. */}
        {!isDemo && (
          <Link to="/sifremi-unuttum" className={girisAltLinkCls}>
            Şifremi unuttum
          </Link>
        )}

        {/* S115: sağlayıcı künyesi. Logo DEKORATİF (alt=""), çünkü hemen ÜSTÜNDEKİ metin
            aynı bilgiyi zaten veriyor — ekran okuyucuda "NewtonTech NewtonTech" olmasın.
            Sıra metin→logo (kullanıcı 2026-08-03), Yerlice ile BİREBİR. Görsel sırayı
            `flex-col-reverse` ile DEĞİL DOM sırasıyla veriyoruz: ters çevirseydik ekran
            okuyucu logoyu önce okur, görsel sırayla ayrışırdı.
            Ölçüler Yerlice ile BİREBİR: mt-24 / logo 28px / metin 12px, gap 8px.
            ⚠️ Bu dosya `VITE_DEMO_MODE=true` ile 3 halka açık demoya da derleniyor;
            künye orada da doğru bilgi olduğu için dal ayrımı gerekmiyor. */}
        <div className="mt-[24px] flex flex-col items-center gap-[8px]">
          <p className="m-0 text-[12px] text-[#6b7280] text-center">
            RaporGör bir NewtonTech ürünüdür.
          </p>
          <img src="/newtontech.png" alt="" className="h-[28px] w-auto block" />
        </div>
      </form>

      {/* Rasathane ufuk şeridi — TAMAMEN DEKORATİF, formun dışında ve sonrasında.
          Yerlice login.css'teki `.rg-login__sahne` ile BİREBİR.
          🔴 `mix-blend-mode` SARMALAYICIDA olmak zorunda, `img`de DEĞİL: `fixed`
          Chromium'da kendi yığın bağlamını yaratır, blend `img`e verilirse görsel
          sayfayla değil o boş bağlamla çarpılır ve şeridin beyaz kutusu görünür kalır.
          `pointer-events-none` şart: şerit forma binerse tıklamayı yutmasın.
          🔴 @640 altında GİZLİ DEĞİL, KIRPIK (kullanıcı 2026-08-03): 5:1 görsel telefonda
          79px'e düşüp okunmaz oluyordu — çözüm küçültmek değil kırpmaktı. 120px sabit
          yükseklik + `object-cover` ölçeği 0,25'e çıkarıyor, `object-position: 100%`
          rasathane kubbesini ekranın ortasına getiriyor. Yerlice login.css ile birebir. */}
      <div
        className="fixed inset-x-0 bottom-0 pointer-events-none select-none mix-blend-multiply max-[640px]:h-[120px] max-[640px]:overflow-hidden"
        aria-hidden="true"
      >
        <img
          src="/rasathane-sahne.webp"
          alt=""
          className="block w-full h-auto max-[640px]:h-[120px] max-[640px]:object-cover max-[640px]:object-[100%_100%]"
        />
      </div>
    </div>
  );
}
